export default {
  baseStyle: {
    track: {
      _checked: {
        bgColor: 'primary.solid',
      },
    },
  },
}
